/**
 * Defensive theme accessors for credit report cards (avoids render crashes).
 */

const FALLBACK = {
  isDark: true,
  card: {
    bg: 'rgba(7,28,21,0.62)',
    border: 'rgba(142,218,182,0.12)',
    shadow: '0 18px 48px rgba(0,0,0,0.26)',
    innerGlow: 'linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0))',
  },
  text: {
    primary: '#EAF7F0',
    secondary: '#C7DDD0',
    muted: '#93AE9F',
  },
  surface: {
    s2: 'rgba(10,34,25,0.58)',
  },
  border: {
    b2: 'rgba(142,218,182,0.10)',
  },
  green: {
    600: '#0D9F64',
    700: '#0B8C58',
  },
  shield: {
    bg: 'rgba(15,172,108,0.12)',
    color: '#56B988',
  },
};

export function getSafeCreditReportTheme(theme) {
  if (!theme || typeof theme !== 'object') {
    return { ...FALLBACK };
  }

  return {
    isDark: theme.isDark ?? FALLBACK.isDark,
    card: { ...FALLBACK.card, ...(theme.card || {}) },
    text: { ...FALLBACK.text, ...(theme.text || {}) },
    surface: { ...FALLBACK.surface, ...(theme.surface || {}) },
    border: { ...FALLBACK.border, ...(theme.border || {}) },
    green: { ...FALLBACK.green, ...(theme.green || {}) },
    shield: { ...FALLBACK.shield, ...(theme.shield || {}) },
  };
}
